import { Primitive } from '../Primitive';
import { Type } from '../Type';
export class Size2D extends Primitive {
    height;
    width;
    constructor(height, width) {
        super(Type.Size2D);
        this.height = height;
        this.width = width;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2l6ZTJELmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9nZW9tZXRyeV8yZC9TaXplMkQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQTtBQUN4QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBRTlCLE1BQU0sT0FBTyxNQUFPLFNBQVEsU0FBUztJQUMxQixNQUFNLENBQVE7SUFDZCxLQUFLLENBQVE7SUFFdEIsWUFBWSxNQUFjLEVBQUUsS0FBYTtRQUN2QyxLQUFLLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQ2xCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFBO1FBQ3BCLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFBO0lBQ3BCLENBQUM7Q0FDRiJ9